export default __webpack_public_path__ + "1009f03324315eb8bb66d610775afe82.woff";